"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Quests = /*#__PURE__*/function () {
  function Quests(client) {
    (0, _classCallCheck2["default"])(this, Quests);
    this.client = client;
  }

  (0, _createClass2["default"])(Quests, [{
    key: "questsHomeGet",
    value: function questsHomeGet() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.client.get("/user/upcoming-quest", args);
    }
  }, {
    key: "allQuest",
    value: function allQuest() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.client.get("/user/all-quest", args);
    }
  }, {
    key: "getProspetityQuest",
    value: function getProspetityQuest(questId) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return this.client.get("/quests/".concat(questId, "/public"), args);
    }
  }, {
    key: "postAskQuestion",
    value: function postAskQuestion(questId, data) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      return this.client.post("/quests/".concat(questId, "/ask-question"), data, args);
    }
  }, {
    key: "postQuestInquiry",
    value: function postQuestInquiry(questId, customFormId, data) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++) {
        args[_key5 - 3] = arguments[_key5];
      }

      return this.client.put("/quests/".concat(questId, "/inquiry-custom-form/").concat(customFormId, "/answers"), data, args);
    }
  }, {
    key: "upcomingQuests",
    value: function upcomingQuests() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return this.client.get("/quests/public", args);
    }
  }, {
    key: "getQuestJourney",
    value: function getQuestJourney(questId) {
      var _this$client;

      for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        args[_key7 - 1] = arguments[_key7];
      }

      return (_this$client = this.client).get.apply(_this$client, ["/journey?questId=".concat(questId)].concat(args));
    }
  }, {
    key: "publicQuestsUpcomingGet",
    value: function publicQuestsUpcomingGet(questId) {
      for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        args[_key8 - 1] = arguments[_key8];
      }

      return this.client.get("/quests/".concat(questId, "/public"), args);
    }
  }, {
    key: "signUpQuests",
    value: function signUpQuests(questId, data) {
      for (var _len9 = arguments.length, args = new Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
        args[_key9 - 2] = arguments[_key9];
      }

      return this.client.post("/quests/".concat(questId, "/inquiries"), data, args);
    }
  }, {
    key: "questsFaculties",
    value: function questsFaculties(questId) {
      for (var _len10 = arguments.length, args = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
        args[_key10 - 1] = arguments[_key10];
      }

      return this.client.get("/quests/".concat(questId, "/faculties"), args);
    }
  }, {
    key: "questsItinerary",
    value: function questsItinerary(questId) {
      for (var _len11 = arguments.length, args = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
        args[_key11 - 1] = arguments[_key11];
      }

      return this.client.get("/quests/".concat(questId, "/Itinerary"), args);
    }
  }, {
    key: "questsGetChecklist",
    value: function questsGetChecklist(questId) {
      for (var _len12 = arguments.length, args = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
        args[_key12 - 1] = arguments[_key12];
      }

      return this.client.get("/quests/".concat(questId, "/participants/checklist"), args);
    }
  }, {
    key: "questsToDoPut",
    value: function questsToDoPut(questId, data) {
      for (var _len13 = arguments.length, args = new Array(_len13 > 2 ? _len13 - 2 : 0), _key13 = 2; _key13 < _len13; _key13++) {
        args[_key13 - 2] = arguments[_key13];
      }

      return this.client.put("/quests/".concat(questId, "/participants/checklist"), data, args);
    }
  }, {
    key: "signUpStatus",
    value: function signUpStatus(questId, userId) {
      for (var _len14 = arguments.length, args = new Array(_len14 > 2 ? _len14 - 2 : 0), _key14 = 2; _key14 < _len14; _key14++) {
        args[_key14 - 2] = arguments[_key14];
      }

      return this.client.get("/quests/".concat(questId, "/inquiries/").concat(userId, "/status"), args);
    }
  }, {
    key: "getToDoListCount",
    value: function getToDoListCount(questId) {
      for (var _len15 = arguments.length, args = new Array(_len15 > 1 ? _len15 - 1 : 0), _key15 = 1; _key15 < _len15; _key15++) {
        args[_key15 - 1] = arguments[_key15];
      }

      return this.client.get("/quests/".concat(questId, "/counts"), args);
    }
  }, {
    key: "getParticularBlog",
    value: function getParticularBlog(blogId) {
      for (var _len16 = arguments.length, args = new Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
        args[_key16 - 1] = arguments[_key16];
      }

      return this.client.get("/quests/blogs/".concat(blogId), args);
    }
  }, {
    key: "getQuestMedias",
    value: function getQuestMedias(questId) {
      for (var _len17 = arguments.length, args = new Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
        args[_key17 - 1] = arguments[_key17];
      }

      return this.client.get("/quests/".concat(questId, "/medias"), args);
    }
  }, {
    key: "getQuestSecondStepEnrollmentProcess",
    value: function getQuestSecondStepEnrollmentProcess(questId, userId) {
      for (var _len18 = arguments.length, args = new Array(_len18 > 2 ? _len18 - 2 : 0), _key18 = 2; _key18 < _len18; _key18++) {
        args[_key18 - 2] = arguments[_key18];
      }

      return this.client.get("/quests/".concat(questId, "/participants/").concat(userId, "/payments"), args);
    }
  }, {
    key: "makePayment",
    value: function makePayment(questId, data) {
      for (var _len19 = arguments.length, args = new Array(_len19 > 2 ? _len19 - 2 : 0), _key19 = 2; _key19 < _len19; _key19++) {
        args[_key19 - 2] = arguments[_key19];
      }

      return this.client.post("/quests/".concat(questId, "/participants/payments"), data, args);
    }
  }, {
    key: "getCustomForm",
    value: function getCustomForm(questId, type) {
      var _this$client2;

      var query = type === 'questInquiry' ? "?type=".concat(type) : '';

      for (var _len20 = arguments.length, args = new Array(_len20 > 2 ? _len20 - 2 : 0), _key20 = 2; _key20 < _len20; _key20++) {
        args[_key20 - 2] = arguments[_key20];
      }

      return (_this$client2 = this.client).get.apply(_this$client2, ["/quests/".concat(questId, "/custom-form").concat(query)].concat(args));
    }
  }, {
    key: "updateCustomFormAnswers",
    value: function updateCustomFormAnswers(questId, customFormId, data) {
      var _this$client3;

      for (var _len21 = arguments.length, args = new Array(_len21 > 3 ? _len21 - 3 : 0), _key21 = 3; _key21 < _len21; _key21++) {
        args[_key21 - 3] = arguments[_key21];
      }

      return (_this$client3 = this.client).put.apply(_this$client3, ["/quests/".concat(questId, "/custom-form/").concat(customFormId, "/answers"), data].concat(args));
    }
  }, {
    key: "getCustomFormAnswersOfUser",
    value: function getCustomFormAnswersOfUser(questId, userId, customFormId) {
      var _this$client4;

      for (var _len22 = arguments.length, args = new Array(_len22 > 3 ? _len22 - 3 : 0), _key22 = 3; _key22 < _len22; _key22++) {
        args[_key22 - 3] = arguments[_key22];
      }

      return (_this$client4 = this.client).get.apply(_this$client4, ["/quests/".concat(questId, "/participants/").concat(userId, "/custom-form/").concat(customFormId, "/answers")].concat(args));
    }
  }, {
    key: "uploadTravelDocument",
    value: function uploadTravelDocument(questId, userId, data) {
      for (var _len23 = arguments.length, args = new Array(_len23 > 3 ? _len23 - 3 : 0), _key23 = 3; _key23 < _len23; _key23++) {
        args[_key23 - 3] = arguments[_key23];
      }

      return this.client.post("/quests/".concat(questId, "/participants/").concat(userId, "/travel-document"), data, args);
    }
  }, {
    key: "getQuestsSteps",
    value: function getQuestsSteps(questId) {
      for (var _len24 = arguments.length, args = new Array(_len24 > 1 ? _len24 - 1 : 0), _key24 = 1; _key24 < _len24; _key24++) {
        args[_key24 - 1] = arguments[_key24];
      }

      return this.client.get("/quests/".concat(questId, "/steps"), args);
    }
  }, {
    key: "getTravelDocumentSignedURL",
    value: function getTravelDocumentSignedURL(questId, contentType, documentType) {
      for (var _len25 = arguments.length, args = new Array(_len25 > 3 ? _len25 - 3 : 0), _key25 = 3; _key25 < _len25; _key25++) {
        args[_key25 - 3] = arguments[_key25];
      }

      return this.client.get("/quests/".concat(questId, "/participants/travel-document/signed-url?fileType=").concat(contentType, "&documentType=").concat(documentType), args);
    }
  }, {
    key: "getTravelDocument",
    value: function getTravelDocument(questId, userId) {
      for (var _len26 = arguments.length, args = new Array(_len26 > 2 ? _len26 - 2 : 0), _key26 = 2; _key26 < _len26; _key26++) {
        args[_key26 - 2] = arguments[_key26];
      }

      return this.client.get("/quests/".concat(questId, "/participants/").concat(userId, "/travel-document"), args);
    }
  }, {
    key: "deleteTravelDocument",
    value: function deleteTravelDocument(questId, userId, fileName, documentType) {
      for (var _len27 = arguments.length, args = new Array(_len27 > 4 ? _len27 - 4 : 0), _key27 = 4; _key27 < _len27; _key27++) {
        args[_key27 - 4] = arguments[_key27];
      }

      return this.client["delete"]("/quests/".concat(questId, "/participants/").concat(userId, "/travel-document?fileName=").concat(fileName, "&documentType=").concat(documentType), args);
    }
  }, {
    key: "downloadTravelDocument",
    value: function downloadTravelDocument(questId, userId, fileName) {
      for (var _len28 = arguments.length, args = new Array(_len28 > 3 ? _len28 - 3 : 0), _key28 = 3; _key28 < _len28; _key28++) {
        args[_key28 - 3] = arguments[_key28];
      }

      return this.client.get("/quests/".concat(questId, "/participants/").concat(userId, "/travel-document/").concat(fileName), args);
    }
  }]);
  return Quests;
}();

exports["default"] = Quests;